import { createTheme } from '@mui/material/styles';

import { THEME_COLOR4 } from '../../../../../constants';

export const menuFormTheme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          // Let the error state override any inline color set on InputLabelProps
          '&.Mui-error': { color: '#d32f2f !important' },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': { color: '#d32f2f' },
        },
      },
    },
  },
});

export const textInputCss = {
  // Default underline colours
  '& .MuiInput-underline:before': { borderBottom: `1.5px solid ${THEME_COLOR4}` },
  '& .MuiInput-underline:after': { borderBottom: `1.5px solid ${THEME_COLOR4}` },
  '& .MuiInput-underline:hover:before': { borderBottom: 0 },
  // Error state — must come last to override the generic rules above
  '& .MuiInput-underline.Mui-error:before': { borderBottom: '1.5px solid #d32f2f !important' },
  '& .MuiInput-underline.Mui-error:after': { borderBottom: '2px solid #d32f2f !important' },
  // Select uses MuiInput-root directly for the underline pseudo-elements
  '&.Mui-error:before': { borderBottomColor: '#d32f2f !important' },
  '&.Mui-error:after': { borderBottomColor: '#d32f2f !important' },
} as const;
